import React, { JSX } from 'react';
import ConnectedPagesGrandparentEdge from './ConnectedPagesGrandparentEdge';
import { IConnectedPage } from '../../../../../types/api/connectedPages/IConnectedPage';
import { getChildPagesCoordinates } from '../utils/ConnectedPagesHelperFunctions';

type ConnectedPagesGraphEdgesProps = {
  containerDimensions: { width: number; height: number };
  parentPageWidth: number;
  childPages: IConnectedPage[];
  maxPagesPerRow: number;
  radiusOfFirstRow: number;
};

export function ConnectedPagesGraphEdges({
  containerDimensions,
  parentPageWidth,
  childPages,
  maxPagesPerRow,
  radiusOfFirstRow,
}: ConnectedPagesGraphEdgesProps) {
  const renderEdge = (page: IConnectedPage, index: number): JSX.Element => {
    const coordinates = getChildPagesCoordinates(containerDimensions, index, maxPagesPerRow, radiusOfFirstRow);
    return (
      <line
        className="connected-pages-graph__svg-line"
        key={`line-${page.pageLink.url}`}
        x1={containerDimensions.width / 2}
        y1={containerDimensions.width / 2}
        x2={coordinates.x}
        y2={coordinates.y}
      />
    );
  };

  return (
    <ConnectedPagesGrandparentEdge diameter={containerDimensions.width} width={parentPageWidth}>
      {childPages.map(renderEdge)}
    </ConnectedPagesGrandparentEdge>
  );
}
